import { ButtonTriggerEvent } from '../../../common/components';

export class AIEventClassificationModalActions {
  confirm: (event: ButtonTriggerEvent, data: any) => void;
  cancel?: () => void;
}

export class AIEventClassificationModalData {
  hubName: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/ai.event.classification.modal/ai.event.classification.modal.provider.ts